(ns ^:dev/always bp-clients.tv-app.api.graphql.purgatorium
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/purgatorium/init_session.graphql"
  "graphql/purgatorium/token.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private init-session-raw (get-in query-map [:mutation :purgatorium-init-session]))
(def ^:private token-valid-raw (get-in query-map [:query :purgatorium-maybe-token]))

(def init-session-mutation
  "Sends an init-session mutation"
  (partial query-builder init-session-raw))

(defn token-valid-query
  "Sends a token-valid query"
  [token]
  (query-builder token-valid-raw (select-keys token [:code :secret])))

(comment
  ;; see the corresponding .graphql files for more impormation
  (token-valid-query {:code "code" :secret "my-secret"})

  (init-session-mutation)

  nil)
